import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createSitInOutbound } from '../../../../api/outbound/pokerOutbounds';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
export const DomSitInButton = ({ bounds }) => {
    const socketSend = useSocketSend();
    const onClickSitIn = useCallback(() => {
        socketSend(createSitInOutbound());
    }, [socketSend]);
    const { x, y, w, h } = bounds;
    return _jsx(ScaledTextButton, { label: 'SIT IN', onClick: onClickSitIn, x: x, y: y, w: w, h: h });
};
